import PortfolioPageLayout from "../PortfolioPageLayout";
import yhaData from "../Yha/yhaData";

function Yha() {
  return <PortfolioPageLayout {...yhaData} />;
}

export default Yha;
